import { useEffect } from "react";
import { toast } from "react-toastify";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ADMIN_KNOWLEDGE_BASE_ENDPOINTS, AdminKnowledgeBaseService } from "@/service/api/admin-knowledge-base";
import { ListAdminKnowledgeBaseDto } from "@/service/dto/admin-knowledge-base";

const useKnowledgeBaseList = (params: ListAdminKnowledgeBaseDto) => {
  const query = useQuery({
    queryKey: [ADMIN_KNOWLEDGE_BASE_ENDPOINTS.LIST, params],
    queryFn: () => AdminKnowledgeBaseService.list(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(getApiErrorMessage(query.error, "Erro ao carregar conteúdos."), { toastId: "knowledge_base_list_error" });
    }
  }, [query.isError, query.error]);

  return query;
};

export default useKnowledgeBaseList;
